const getPeriodesWeek = (date) => {
    const currentDate = new Date(date)
    let year = currentDate.getFullYear();
    let yearStart = new Date(year,0,1);

    let getCurrentWeek = Math.ceil(( ( (currentDate - yearStart) / 86400000) + yearStart.getDay()+ 1)/7);

    return getCurrentWeek
} 

export default getPeriodesWeek

